export const BLIK_MODEL = {
  model0: 'BLIK_MODEL_O',
  modelM: 'BLIK_MODEL_M',
}

export const BLIK_ERROR = {
  recurrencyNotSupported: 'RECURRENCY_NOT_SUPPORTED',
  wrongTicket: 'WRONG_TICKET',
}

export const BLIK_RECURRING_ACTION = {
  initWithoutPayment: 'INIT_WITHOUT_PAYMENT',
  initWithPayment: 'INIT_WITH_PAYMENT',
  initWithRefund: 'INIT_WITH_REFUND',
}

// Kod BLIK to 6 cyfr wyświetlanych jako `### ###`. Maska pola i walidator (`REGEXPS.blikValidator`)
// przyjmują zwykłą spację, więc sanityzacja zawsze zwraca ten zapis, nigdy same cyfry.
export const BLIK_CODE_LENGTH = 6
export const BLIK_CODE_MASK = '### ###'
